import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.detalle.editar.movimientos', {
    template: '<ui-view></ui-view>',
    url: '/movimientos',
    abstract: true,
    params: {idMoneda: {value: '1', squash: false}},
    data: {titleProxy: 'finances.cuentasBancarias.detalle.editar.movimientos.buscar'},
    resolve: {
      idEmpleado: (cuenta) => cuenta.id_cuenta_kardex,
      idMoneda: ($http, idEmpresa, idCuenta) => {
        return $http.get('/api/empresa/cuenta/moneda', {params: {id_empresa: idEmpresa, id_cuenta: idCuenta}})
          .then((response) => response.data.id)
      },
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/routes/cuentasBancarias/detalle/editar/movimientos.js